export const debounce = <T extends (...args: any[]) => void>(
  func: T,
  delay = 300
): (...args: Parameters<T>) => void => {
  let timer: ReturnType<typeof setTimeout>;

  return function(...args: Parameters<T>) {
    clearTimeout(timer);
    // @ts-ignore
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};
